import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const legacyReportsCreatedVsResolvedRoute: InvariantJiraRoute = {
	name: 'legacy-reports-created-vs-resolved-report',
	path: '/secure/ConfigureReport([!%]?[\\w]*).jspa',
	query: ['reportKey=com.atlassian.jira.plugin.system.reports:createdvsresolved-report'],
};
